/**
 * Formats the official timesheet approver for the PTS location header (AE2-6953).
 * Client: "Approved By: Trenise Jones (Client)"
 * Associate: "Approved By: Trenise Jones (LT)"
 */
export const formatTimesheetApproverLabel = (approver) => {
    if (!approver) return null;

    const name = [approver.firstName, approver.lastName]
        .filter((part) => Boolean(part && String(part).trim()))
        .join(' ')
        .trim();
    const displayName = name || approver.email?.trim();

    if (!displayName) return null;

    return `Approved By: ${displayName} (${approver.isLtAssociate ? 'LT' : 'Client'})`;
};
